import React, { useEffect, useState, useRef } from 'react';
import { Col, Form, Row } from 'antd';
import { FormField, RadioGroup } from 'components';
import { updateFormField } from 'store/forms/actions';
import {
  formFieldsLegalRepresentative,
  formFieldsContactPerson,
} from './formFields';
import { useDispatch, useSelector } from 'react-redux';
import { get, omit } from 'lodash';
import moment from 'moment';
import { useForm } from 'antd/lib/form/Form';
import { getOtp } from 'store/forms/actions';
import { OtpModal } from 'components/layout/components';
import { CheckCircleOutlined } from '@ant-design/icons';
import { isBeneficiary } from 'utils';

const RepresentativesDetails = () => {
  const [form] = useForm();
  const dispatch = useDispatch();
  const carrier = useSelector(state => state.forms.carrier);
  const privileges = useSelector(state => state.user.privileges);
  const user = useSelector(state => state.user);
  const task = useSelector(state => state.forms.task);
  const viewMode = useSelector(state => state.forms.carrier.viewMode);
  const [otpModalOpen, setOptModalOpen] = useState(false);
  const [otpValidateParams, setOtpValidateParams] = useState({});
  const [cancelOtp, setCancelOtp] = useState('');

  useEffect(() => {
    const formRepresentative = Object.values(formFieldsLegalRepresentative).map(
      field => field.name
    );

    var formPerson = null;
    if (carrier.contactPersonFlag === false) {
      formPerson = Object.values(formFieldsContactPerson).map(
        field => field.name
      );
    }
  }, [carrier]);

  const handleChange = ({ key, type, event }) => {
    let newValue;
    if (
      type === 'text' ||
      type === 'textarea' ||
      type === 'radio' ||
      type === 'select'
    ) {
      newValue = event.target.value;
    } else if (type === 'date') {
      newValue = new Date(event).toLocaleDateString();
    }
    dispatch(
      updateFormField({
        group: 'carrier',
        key,
        value: newValue,
      })
    );

    if((key === 'legalPhone' && carrier?.legalPhoneValidated) ||
       (key === 'legalEmail' && carrier?.legalEmailValidated) || 
       (key === 'contactPhone' && carrier?.contactPhoneValidated) ||
       (key === 'contactEmail' && carrier?.contactEmailValidated)){
      dispatch(
        updateFormField({
          group: 'carrier',
          key: key+'Validated',
          value: false,
        })
      );
    }
  };

  useEffect(()=>{
    if(cancelOtp === 'legalPhone'|| cancelOtp === 'legalEmail' || cancelOtp === 'contactPhone' || cancelOtp === 'contactEmail'){
        dispatch(
          updateFormField({
            group: 'carrier',
            key: cancelOtp+'Validated',
            value: false,
          })
        );
    }

  },[cancelOtp])

  const renderFieldValue = field => {
    const value = get(carrier, field.name, '');
    return field.type === 'date' ? (value ? moment(value) : '') : value;
  };

  const verifyOtp = (fieldName) => {
    const params = {
      processInstanceId: task.processInstanceId,
      fieldName: fieldName === 'legalPhone' || fieldName === 'contactPhone' ? 'mobile' : 'email',
      fieldValue : carrier?.[fieldName],
      field: fieldName,
    }
    setOtpValidateParams(params);
    if(carrier?.[fieldName]){
      dispatch(getOtp(params));
      setOptModalOpen(true);
    }
  }
  
  return (
    <div className=''>
      <OtpModal
        isVisible={otpModalOpen}
        setVisible={setOptModalOpen}
        otpValidateParams={otpValidateParams}
        cancelOtp={cancelOtp}
        setCancelOtp={setCancelOtp}
      />
    <Form
      form={form}
      name="representativeDetails"
      initialValues={{
        ...carrier,
      }}
      trigger="onChange"
    >
      <div className="carrier-data-form">
        <p className="mt-0 mr-0 color-blue-3 text-bold font-size-19">
          Νόμιμος Εκπρόσωπος
        </p>
        <Row
          gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
          className="carrier-data-form__row"
          align="top"
        >
          {formFieldsLegalRepresentative.map((field, index) => (
            field.name !== "legalPhone" && field.name !== "legalEmail" ?
            <Col key={index} className="gutter-row" span={field.span}>
              <Form.Item
                name={field.name}
                value={renderFieldValue(field)}
                validateFirst
                onChange={value =>
                  handleChange({
                    key: field.name,
                    type: field.type,
                    event: value,
                  })
                }
                rules={field.rules}
              >
                <FormField
                  {...omit(field, ['span', 'rules'])}
                  key={index}
                  disabled={viewMode || !isBeneficiary(user.groups)}
                />
              </Form.Item>
            </Col>
            :
            <Col key={index} className="gutter-row" span={field.span}>
              <Form.Item
                name={field.name}
                value={renderFieldValue(field)}
                validateFirst
                onChange={value =>
                  handleChange({
                    key: field.name,
                    type: field.type,
                    event: value,
                  })
                }
                rules={field.rules}
              >
                <FormField
                  {...omit(field, ['span', 'rules','label'])}
                  key={index}
                  disabled={viewMode || !isBeneficiary(user.groups)}
                  label={field.label}
                />
              </Form.Item>
            </Col>
          ))}
        </Row>
      </div>
      <div className="carrier-data-form carrier-data-form__right">
        <p className="mt-0 mr-0 color-blue-3 text-bold font-size-19">
          Υπεύθυνος Επικοινωνίας
        </p>
        <Row
          gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
          className="carrier-data-form__row"
        >
          <Col
            key={1}
            className="gutter-row"
            span={'24'}
            style={{ marginBottom: '2.4rem' }}
          >
            <RadioGroup
              label="Είναι ο Νόμιμος Εκπρόσωπος ίδιος με τον Υπεύθυνο Επικοινωνίας;"
              defaultValue={true}
              options={[
                { label: 'Ναι', value: true },
                { label: 'Όχι', value: false },
              ]}
              name={'contactPersonFlag'}
              checked={carrier.contactPersonFlag}
              disabled={viewMode || !isBeneficiary(user.groups)}
              value={carrier.contactPersonFlag}
              onChange={event =>
                handleChange({
                  key: event.target.name,
                  type: 'radio',
                  event,
                })
              }
            />
          </Col>
          {carrier.contactPersonFlag === false &&
            formFieldsContactPerson.map((field, index) => (
              field.name !== "contactPhone" && field.name !== "contactEmail" ?
              <Col key={index} className="gutter-row" span={field.span}>
                <Form.Item
                  name={field.name}
                  value={renderFieldValue(field)}
                  validateFirst
                  size={field.size}
                  onChange={value =>
                    handleChange({
                      key: field.name,
                      type: field.type,
                      event: value,
                    })
                  }
                  rules={field.rules}
                >
                  <FormField
                    {...omit(field, ['span', 'rules'])}
                    disabled={viewMode || !isBeneficiary(user.groups)}
                    key={index}
                  />
                </Form.Item>
              </Col>
              :
              <Col key={index} className="gutter-row" span={field.span}>
              <Form.Item
                name={field.name}
                value={renderFieldValue(field)}
                validateFirst
                size={field.size}
                onChange={value =>
                  handleChange({
                    key: field.name,
                    type: field.type,
                    event: value,
                  })
                }
                rules={field.rules}
              >
                <FormField
                  {...omit(field, ['span', 'rules', 'label'])}
                  disabled={viewMode || !isBeneficiary(user.groups)}
                  key={index}
                  label={field.label}
                />
              </Form.Item>
            </Col>


            ))}
        </Row>
      </div>
    </Form>
  </div>
  );
};

export default RepresentativesDetails;
